import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import SwalAlertComp from "../../../components/SwalAlert";
import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getAllLeadConnectionAsync = createAsyncThunk(
    "leadConnection/getAllLeadConnection",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/lead/connection`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getSingleConnectionRedux = createAsyncThunk(
    "tracker/getSingleConnection",
    async (id, { rejectWithValue, signal }) => {
        try {
            const response = await axios.get(
                `${baseURL}/api/lead/connection/${id}`,
                RequestConfig({ signal }),
            );
            return response.data && response.data;
        } catch (error) {
            // Let RTK mark the action as aborted (action.meta.aborted) instead of failed.
            if (axios.isCancel(error)) {
                throw error;
            }
            return rejectWithValue({
                ...error?.response?.data,
                status: error?.response?.status,
            });
        }
    },
);

export const refreshSource = createAsyncThunk(
    "tracker/refreshSource",
    async (sourceAccountID) => {
        try {
            const response = await axios.get(
                `${baseURL}/api/lead/facebook/reload-pages?source_account_id=${sourceAccountID}`,
                RequestConfig(),
            );
            SwalAlertComp({
                title: "Success",
                message: "Source pages and forms fetched succesfully.",
                icon: "success",
                timer: 3000,
            });
            return response.data;
        } catch (error) {
            SwalAlertComp({
                title: "Failed",
                message:
                    error?.response?.data?.message || "Something went wrong!",
                icon: "error",
                timer: 3000,
            });
            throw error?.response?.data;
        }
    },
);
